


















































import { Employe } from "../../models/Employe";
import Planning = Employe.Planning;
import PlanningModalEditDayHours from "./PlanningModalEditDayHours.vue";

export default {
    name: "PlanningModalEdit",
    components: { PlanningModalEditDayHours },
    props: {
        planning: Planning,
    },
    data() {
        return {
            EWorkingHourDay: Employe.EWorkingHourDay,
        };
    },
};
